import React, { useState } from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import cx from "clsx";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { Button } from "../../../../../../shared/Button/Button";
import { svg } from "../../../../../../assets/svg";
import { Modal } from "../../../../../../shared/Modal/Modal";
import { Box } from "../../../../../../shared/Box/Box";
import { DateRangePicker } from "../../../../../../shared/DateRangePicker/DateRangePicker";
import { useCurrentUserQuery } from "../../../../../../api/queries/useUserQuery";
import DownloadDropdown from "../../../../components/DownloadDropdown";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";
import classes from "../../../../newBusinessInsightsContent.module.scss";

const modalInfoRows = [
  "membershipOverviewReport.info.newMembers",
  "membershipOverviewReport.info.activeMemberships",
  "membershipOverviewReport.info.canceledMemberships",
  "membershipOverviewReport.info.nextAppt",
  "membershipOverviewReport.info.loyalty",
];

export function Header({
  isFilterActive,
  onFilterOpen,
  period,
  isReportsLoading,
  requestParams,
}) {
  const { tBi } = useAppTranslation.BusinessInsights();
  const { tCommon } = useAppTranslation.Common();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const { data: user } = useCurrentUserQuery();

  const modalInfo = {
    title: "membershipOverviewReport.info.title",
    rows: modalInfoRows,
  };

  return (
    <Box className={cx("m-b-20 membership-title", classes.headerBox)}>
      <div className="flex items-center gap-8 m-b-5">
        {tBi("membershipOverviewReport.label")}
        <Button
          size="small"
          variant="text"
          className={classes.infoButton}
          onClick={() => setIsInfoModalOpen(true)}
        >
          <img src={svg.infoPrimary} alt="info" width="20px" />
        </Button>
      </div>
      <div className={cx(classes.headerActions)}>
        <DateRangePicker
          size="small"
          dateFormat={user?.dateFormat}
          onChange={({ startDate, endDate }) => {
            period.update({
              from: startDate,
              to: endDate,
            });
          }}
          value={{
            startDate: period.value.from,
            endDate: period.value.to,
          }}
          isDisabled={isReportsLoading}
        />
        <DownloadDropdown
          params={requestParams}
          downloadRoute={HTTP_ENDPOINTS.getMembershipOverview()}
        />
        <Button
          size="small"
          variant="outlined"
          onClick={onFilterOpen}
          isDisabled={isReportsLoading}
          leftAdornment={
            isFilterActive ? (
              <img src={svg.filterPrimaryActive} alt="filter" width="16px" />
            ) : (
              <img src={svg.filterPrimary} alt="filter" width="14px" />
            )
          }
        >
          {tCommon("label.filter")}
        </Button>
      </div>
      <Modal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
        header={<Modal.Title>{tBi(modalInfo.title)}</Modal.Title>}
        contentClassName={classes.infoModalContent}
      >
        {modalInfo.rows.map((key) => (
          <p key={key}>
            <Trans
              i18nKey={tBi(key)}
              components={{
                b: <b />,
              }}
            />
          </p>
        ))}
      </Modal>
    </Box>
  );
}

Header.propTypes = {
  isFilterActive: PropTypes.bool.isRequired,
  onFilterOpen: PropTypes.func.isRequired,
  period: PropTypes.shape({
    value: PropTypes.shape({
      from: PropTypes.instanceOf(Date),
      to: PropTypes.instanceOf(Date),
    }),
    update: PropTypes.func,
  }).isRequired,
  isReportsLoading: PropTypes.bool.isRequired,
  requestParams: PropTypes.object.isRequired,
};
